import { storageLocationIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod";

export const recordAdHocBinPick = {
  name: "recordAdHocBinPick" as const,
  input: z.object({
    fulfillmentGroupId: z.string(),
    transferSessionId: z.string(),
    pickSessionId: z.string().nullish(),
    itemExternalId: z.string(),
    binSelections: z.record(
      z.string(),
      z.array(
        z.object({
          storageLocationId: storageLocationIdFormat.schema,
          quantity: z.number(),
        }),
      ),
    ),
    receiveFromExternal: z.boolean().optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
